module.exports = __webpack_public_path__ + "assets/img/07afe079d1872c676a2759066f597b91.png";